import { LinkDetails } from '../../types/types';
import { BASEURL, ENDPOINTS } from '../endpoints';
import { SPXAPI, SPXEndpoint } from '../interfaces';

/**
 * Authenticated full link metadata.
 * Public GET /links/{linkId} strips PII; use this after the recipient is signed in.
 *
 * - SaaS (Cognito IAM): GET /links/{linkId}/session
 * - On-prem (API key via API_PROXY): GET /ext/links/{linkId}
 */
const getInternalLinkData = async (
    API: SPXAPI,
    linkId: string,
    hasApiProxy = false,
): Promise<LinkDetails> => {
    const endpoint: SPXEndpoint = hasApiProxy
        ? ENDPOINTS.getExtLinkDetails(linkId)
        : ENDPOINTS.getSessionLinkDetails(linkId);
    return API.get(BASEURL.backend(), endpoint, {});
};

export default getInternalLinkData;
